import { createReducer, on } from '@ngrx/store';
import { Category } from '@/model/category';
import { OfferWithImage } from '@/model/offer-with-image';
import * as TrendingCategoriesActions from './trending-categories.actions';

export interface TrendingCategoriesState {
  parentCategories: Category[];
  allOffers: OfferWithImage[];
  filteredOffers: OfferWithImage[];
  selectedCategoryId: string | null;
  loading: boolean;
  error: string | null;
}

export const initialState: TrendingCategoriesState = {
  parentCategories: [],
  allOffers: [],
  filteredOffers: [],
  selectedCategoryId: null,
  loading: false,
  error: null,
};

export const trendingCategoriesReducer = createReducer(
  initialState,
  on(TrendingCategoriesActions.loadTrendingData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    TrendingCategoriesActions.loadTrendingDataSuccess,
    (state, { offers, categories }) => ({
      ...state,
      allOffers: offers,
      parentCategories: categories,
      loading: false,
      error: null,
    }),
  ),
  on(TrendingCategoriesActions.loadTrendingDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: typeof error === 'string' ? error : 'Failed to load trending data',
  })),
  on(TrendingCategoriesActions.selectCategory, (state, { categoryId }) => {
    const filtered = state.allOffers.filter((offer) =>
      offer.categories.some((c) => c.id === categoryId),
    );
    return {
      ...state,
      selectedCategoryId: categoryId,
      filteredOffers: filtered,
    };
  }),
  on(TrendingCategoriesActions.applyInitialCategoryFilter, (state) => {
    const firstCategory = state.parentCategories[0];
    if (firstCategory) {
      const filtered = state.allOffers.filter((offer) =>
        offer.categories.some((c) => c.id === firstCategory.id),
      );
      return {
        ...state,
        selectedCategoryId: firstCategory.id,
        filteredOffers: filtered,
      };
    }
    return state;
  }),
  on(TrendingCategoriesActions.resetTrendingCategories, () => initialState),
);
